import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy} from "@angular/core";
import {Apollo} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../shared/redux-store/store";
import {fetchSuppliersQuery} from "../crm/services/supplier/supplier.service";
import {fetchPropertiesQuery} from "./services/property-service/property.service";
import {fetchPackingUnitsQuery} from "./services/packing-unit/packing-unit.service";
import {fetchStockItemCategoriesQuery} from "./services/stock-item-category.service";
import {fetchSubstanceGroupsQuery, fetchSubstancesQuery} from "./services/medicine.service";
import {fetchManufacturersQuery} from "../crm/services/manufacturer.service";
import {fetchUserQuery} from "../organization/services/administration_unit_service/administration-unit.service";
import {fetchCountriesQuery} from "../core/visbos-core/services/address.service";
import {Subscription} from "apollo-client";
import {StockItemService} from "./services/stock-item-service/stock-item.service";
import {AbstractVisbosComponent} from "../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../shared/actions/session.actions";

@Component({
  selector: 'vb-store-management',
  templateUrl: './store-management.component.html',
  styleUrls: ['./store-management.component.css']
})
export class StoreManagementComponent extends AbstractVisbosComponent implements AfterViewInit, OnDestroy {

  title = 'Lagerverwaltung';

  private queries: any[] = [fetchUserQuery, fetchSuppliersQuery, fetchManufacturersQuery, fetchPropertiesQuery, fetchPackingUnitsQuery, fetchStockItemCategoriesQuery, fetchSubstanceGroupsQuery, fetchCountriesQuery,
    fetchSubstancesQuery];

  private prefetchQueryFunctions: Function[] = [];

  private querySubs: Subscription[] = [];


  constructor(sessionActions: SessionActions, private ngRx: NgRedux<IAppState>, private apollo: Apollo, private stockItemService: StockItemService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    /*this.queries.forEach(q => {
      let sub = this.apollo.query({
        query: q,
        variables: {
          AU: this.ngRx.getState().session.activeAdminUnit,
          cuid: null,
          searchString: null
        }
      }).subscribe();
      this.querySubs.push(sub);
    });

    this.querySubs.push(this.stockItemService.prefetchStockItems());*/

  }

  ngOnDestroy(): void {
    this.querySubs.forEach(sub => sub.unsubscribe());
  }


}



// WEBPACK FOOTER //
// ./src/app/store-management/store-management.component.ts